import React from 'react';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      minHeight: '300px',
      padding: '2rem',
      color: 'var(--text-secondary)',
      textAlign: 'center',
      background: 'var(--surface-glass)',
      border: '1px dashed var(--surface-glass-border)',
      borderRadius: 'var(--radius-lg)',
      boxSizing: 'border-box'
    }}>
      <div style={{ 
        fontSize: '3rem', 
        marginBottom: '1.5rem', 
        opacity: 0.8,
        background: 'var(--surface-raised)',
        width: '80px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        boxShadow: 'var(--shadow-sm)'
      }}>
        {icon ?? '📭'}
      </div>
      <h3 style={{ margin: '0 0 0.5rem 0', color: 'var(--text-primary)', fontSize: '1.25rem', fontWeight: 600 }}>
        {title}
      </h3>
      <p style={{ margin: '0 0 1.5rem 0', maxWidth: '400px', lineHeight: 1.5 }}>
        {description}
      </p>
      {action && (
        <div style={{ marginTop: '0.5rem' }}>
          {action}
        </div>
      )}
    </div>
  );
}
